module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraLight.87daf3fd.ttf";